export class BusinessInfoConstant {
    static readonly SSN: string = "SSN";
    static readonly EIN: string = "EIN";
    static readonly BUSINESS_INFO: string = "BUSINESS_INFO";
    static readonly DEFAULT_COUNTRY_CODE: string = "US";
}